import { MediaType } from '~/content/types';

export function isTextIdea({ content }) {
  if (!content) return false;
  const { media, text } = content;

  return (!media || !media.length) && text && text.length;
}

export function isIdeaMediaOfType({ content }, type) {
  if (!content) return false;
  const { media } = content;

  return media && media.find((m) => m.type === type);
}

export function isImageIdea(idea) {
  if (!idea.content) return false;
  let { text } = idea.content;
  text = text?.trim();

  return (
    (isIdeaMediaOfType(idea, MediaType.image) ||
      isIdeaMediaOfType(idea, MediaType.gif)) &&
    (!text || !text.length)
  );
}

export function isVideoIdea(idea) {
  if (!idea.content) return false;
  let { text } = idea.content;
  text = text?.trim();

  return isIdeaMediaOfType(idea, MediaType.video) && (!text || !text.length);
}

export function isMixedIdea({ content }) {
  if (!content) return false;
  const { media, text } = content;

  return (
    media &&
    media.find((m) =>
      [MediaType.video, MediaType.image, MediaType.gif].includes(m.type)
    ) &&
    text &&
    text.length
  );
}

export function sanitizeString(string) {
  const text = new DOMParser().parseFromString(string, 'text/html');
  return text.body.textContent || '';
}

export function highlightLinks(text) {
  const sanitizedText = sanitizeString(text);
  return sanitizedText.replace(
    /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gi,
    '<b>$&</b>'
  );
}
